import React from "react";
import { Row, Typography } from "antd";

import cardLinkRequestEmptyImg from "media/customer-complaint-empty.svg";

const { Text } = Typography;

export default function Empty(props) {
	return (
		<>
			<Row
				type="flex"
				justify="center"
				align="middle"
				style={{
					flexDirection: "column",
					height: "100vh",
				}}>
				<img
					src={cardLinkRequestEmptyImg}
					style={{
						width: "25vw",
						margin: "0 auto",
					}}
					alt="No Card Links Illustrator"
				/>
				<Text style={{ textAlign: "center", fontSize: "20px", color: "black", fontWeight: "bold", marginTop: "20px" }}>
					{/* You have not received any <span role="img">💳</span> Card Complaint yet. */}
					You have not received any{" "}
					<span role="img" aria-label="credit card emoji">
						📧
					</span>{" "}
					Customer Complaint yet.
					{/* {props.activeKey === "1" ? "queue": "resolved list"}. */}
				</Text>
				<Text style={{ textAlign: "center" }}>You will view the customer complaints here!</Text>
			</Row>
		</>
	);
}
